import { render, staticRenderFns } from "./ScoreDetailForm.vue?vue&type=template&id=2a4b9a39&scoped=true"
import script from "./ScoreDetailForm.vue?vue&type=script&lang=js"
export * from "./ScoreDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ScoreDetailForm.vue?vue&type=style&index=0&id=2a4b9a39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b9a39",
  null
  
)

export default component.exports